import {combineReducers} from 'redux'
import SuppliersReducer from './supplier_reducer';

const rootReducer = combineReducers({
  suppliers: SuppliersReducer
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js